(function () {
  'use strict';

  angular
  .module('filter.price', [])

  /* @ngInject */
  .filter('price', ["AppService", function (AppService) {
    var params = null;

    function priceFilter(prices, str, ttc) {
      if (prices === null) return prices;
      ttc = ttc === 'ht' ? false : true;

      if (params !== null) {
        return !angular.isFunction(params.then) ? getPriceFilter(prices, str, ttc) : undefined;
      }
      params = AppService.getParams()
        .then(function (data) {
          params = data;
        })
        .catch(function (error) {
          console.error(error);
        });
    }

    function getPriceFilter(prices, str, ttc) {
      var loc = params.Localization,
        value,
        template = params.Visitor.CardType.ShowTTCPrice ? loc.PriceHTMLFormatVATincluded : loc.PriceHTMLFormatVATexcluded;

      switch (str) {
      case 'value':
            value = prices;
            template = ttc ? loc.PriceHTMLFormatVATincluded : loc.PriceHTMLFormatVATexcluded;
              break;

      case 'amount-price':
            value = params.Visitor.CardType.ShowTTCPrice ? prices.TTCAmount : prices.HTAmount; 
              break;

      case 'amount-price-ttc':
            value = prices.TTCAmount;
              break;

      case 'price-by-quantity':
            value = params.Visitor.CardType.ShowTTCPrice ? prices.TTCDiscountedPriceByQuantity : prices.HTDiscountedPriceByQuantity; 
              break;

      case 'final-price':
              value = params.Visitor.CardType.ShowTTCPrice ? prices.TTCDiscountedPrice : prices.HTDiscountedPrice;
              template = ttc ? loc.PriceHTMLFormatVATincluded : loc.PriceHTMLFormatVATexcluded;
              break;

      case 'final-price-ht':
            value = prices.HTDiscountedPrice;
            template = ttc ? loc.PriceHTMLFormatVATincluded : loc.PriceHTMLFormatVATexcluded;
              break;

      case 'final-price-ttc':
            value = prices.TTCDiscountedPrice;
            template = ttc ? loc.PriceHTMLFormatVATincluded : loc.PriceHTMLFormatVATexcluded;
              break;

      default:
        value = params.Visitor.CardType.ShowTTCPrice ? prices.TTCPrice : prices.HTPrice;
      }
      var render = template.replace('[%amount%]', format(loc.PriceFormat, parseFloat(value)))
                           .replace(',', '##PriceTSep##')
                           .replace('.', loc.PriceDecimalSeparator)
                           .replace('[%amountCode%]', format(loc.PriceFormat, parseFloat(value)))
                           .replace('##PriceTSep##', loc.PriceThousandSeparator)
                           .replace('[%currency%]', params.Currency.Symbol)
                           .replace('[%currencyCode%]', params.Currency.ISOCode);

      return render;
    }

    priceFilter.$stateful = true;
    return priceFilter;

  }]);

})();
